var React = require('react');

function IconLockedInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"stroke":"#000","strokeWidth":"5","fill":"#FFF","cx":"50","cy":"50","r":"47.5","key":0}),React.createElement("path",{"d":"M61 42.667h-1.833V39c0-5.06-4.107-9.167-9.167-9.167S40.833 33.94 40.833 39v3.667H39a3.677 3.677 0 0 0-3.667 3.666v18.334A3.677 3.677 0 0 0 39 68.333h22a3.677 3.677 0 0 0 3.667-3.666V46.333A3.677 3.677 0 0 0 61 42.667zM44.5 39c0-3.043 2.457-5.5 5.5-5.5s5.5 2.457 5.5 5.5v3.667h-11V39zM61 64.667H39V46.333h22v18.334zm-11-5.5a3.677 3.677 0 0 0 3.667-3.667A3.677 3.677 0 0 0 50 51.833a3.677 3.677 0 0 0-3.667 3.667A3.677 3.677 0 0 0 50 59.167z","fill":"#000","fillRule":"nonzero","key":1})]));
}

IconLockedInline.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = IconLockedInline;

IconLockedInline.default = IconLockedInline;
